/**
 * Isidora sounds in D aeolian — a mode that will not resolve, which suits a
 * city you arrive at too late. The violins are tuned from this set; the pad
 * and the drone take their roots from it too.
 */
const A4 = 440;
const NAMES = ['C', 'C#', 'D', 'D#', 'E', 'F', 'F#', 'G', 'G#', 'A', 'A#', 'B'];

/** 'D3' → 146.83 Hz */
export function noteToHz(note) {
  const m = /^([A-G]#?)(-?\d)$/.exec(note);
  if (!m) throw new Error(`[scales] bad note "${note}"`);
  const semitone = NAMES.indexOf(m[1]);
  const octave = Number(m[2]);
  const midi = semitone + (octave + 1) * 12;
  return A4 * Math.pow(2, (midi - 69) / 12);
}

/** Open strings of a violin, for the ones that are only resonating. */
export const OPEN_STRINGS = ['G3', 'D4', 'A4', 'E5'];

/** The voices assigned down the stair, low at the top, aching higher below. */
export const VIOLIN_VOICES = ['D3', 'A3', 'F4', 'C4', 'G4', 'A4', 'D5', 'E5', 'C5'];

/** The pad: a stacked D minor eleventh, spread wide. */
export const PAD_CHORD = ['D2', 'A2', 'D3', 'F3', 'C4', 'G4'];

export const DRONE_ROOT = 'D1';

export function hzFor(note) {
  return noteToHz(note);
}

export function detuneCents(hz, cents) {
  return hz * Math.pow(2, cents / 1200);
}
